import React from 'react';
import Lottie from "lottie-react";

import PropTypes from 'prop-types'
import styles from './Loader.module.css';

const loadingAnimation = require('./imgs/cookie-loader.json');

const Loader = ({ className }) => (
  <div className={[styles.loaderWrapper, className].join(' ')}>
    <Lottie 
      animationData={loadingAnimation} 
      autoPlay 
      loop
    />
  </div>
)

Loader.propTypes = {
  className: PropTypes.string
}

Loader.defaultProps = {
  className: ''
}

export default Loader;
